import { useRef, useEffect } from 'react'
import { urlForImage } from 'lib/sanity.image'
import { animate, motion } from 'motion/react'
import Image from 'next/image'
import { formatCurrency } from 'lib/helpers'

export const CounterHero = ({ image, heading }) => {
  const text = heading.split(/\$((?:\d|\,)*\.?\d+)/g)
  return (
    <div className="relative flex h-screen w-full p-20">
      <div className="relative flex flex-1 items-center justify-center overflow-hidden rounded-12 bg-white p-40">
        <Image
          src={urlForImage(image).width(1000).dpr(3).url()}
          fill
          style={{ objectFit: 'cover' }}
          alt={image.alt ?? `${heading}`}
          placeholder="blur"
          blurDataURL={image.lqip}
        />
        <motion.div
          className="z-[2] text-center text-18 leading-100 text-white lg:text-[2vw]"
          initial={{ opacity: 0, filter: 'blur(10px)' }}
          animate={{ opacity: 1, filter: 'blur(0px)' }}
          transition={{ duration: 1.2, ease: [0.8, 0.1, 0.1, 0.9] }}
        >
          {text.map((t, i) => {
            if (t.match(/^-?\d*,.?\d*$/)) {
              const number = parseFloat(t.replace(/,/g, ''))
              return <Counter key={i} number={number} />
            }
            return t
          })}
        </motion.div>
      </div>
    </div>
  )
}

const Counter = ({ number }) => {
  const ref = useRef<HTMLSpanElement>(null)
  const from = number * 0.7
  const to = number

  useEffect(() => {
    const node = ref.current

    if (!node) return

    const controls = animate(from, to, {
      duration: 2.2,
      delay: 0.6,
      ease: 'easeOut',
      onUpdate(value) {
        node.textContent = formatCurrency(Math.round(value))
      },
    })

    return () => controls.stop()
  }, [from, to])

  return <span className="tabular-nums" ref={ref} />
}
